////////////////////////////////////////////////////////////////////////////////
//                                                                            //
//  IRONSIDE - Public Website GUI                                             //
//                                                                            //
//  Version: 1.0.1                                                            //
//  Summary: Controlled multi-line text input                               //
//                                                                            //
////////////////////////////////////////////////////////////////////////////////

import type { TextareaHTMLAttributes } from 'react';

export interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  id: string;
  invalid?: boolean;
}

export function TextArea ({ invalid = false, className = '', rows = 5, ...rest }: TextAreaProps) {
  return (
    <textarea
      aria-invalid={invalid}
      rows={rows}
      className={`rounded border px-3 py-2 text-ink outline-none focus:ring-2 focus:ring-ink/40 ${invalid ? 'border-red-600' : 'border-line'} ${className}`}
      {...rest}
    />
  );
}
